import _ from "lodash";
import { takeLatest, call, put } from "redux-saga/effects";
import { fetchProjectEmailNotificationHistory } from "../../../services/projects";
import * as actions from "../projectActions";
export default function* fetchEmailNotificationHistoryByProjectWatcher() {
  yield takeLatest(actions.FETCH_PROJECT_EMAIL_NOTIFICATION_HISTORY, fetchEmailNotificationHistoryByProjectWorker);
}
export function* fetchEmailNotificationHistoryByProjectWorker(action) {
  try {
    const response = yield call(fetchProjectEmailNotificationHistory, {
      closing_id: parseInt(action.closing_id),
    });
    yield call(success, response);
  } catch (error) {
    yield call(failure, error);
  }
}

export function* success(response) {
  yield put(actions.setProjectEmailNotificationHistory(_.get(response, 'data.fetchProjectEmailNotificationHistory', [])));
}

export function* failure(error) {
  yield put(actions.statusError(error));
}